module.exports = __webpack_public_path__ + "static/media/Menu.ad184dc4.svg";